// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ice: CountryValidator<"MA"> = createValidator(
  "ma.ice",
  121,
);

export default ice;
export const compact = ice.compact;
export const format = ice.format;
export const validate = ice.validate;
export const generate = (): string =>
  ice.generate?.() ??
  (() => {
    throw new Error(
      "Validator ma.ice cannot generate values",
    );
  })();
